import React from 'react';
import { FacebookIcon, TwitterIcon, InstagramIcon, LinkedInIcon } from '../Icons/Icons';
import './Footer.css';

function Footer() {
  const cities = ['Karachi', 'Lahore', 'Islamabad', 'Rawalpindi', 'Faisalabad', 'Multan', 'Peshawar', 'Quetta'];
  const propertyTypes = ['Houses', 'Flats', 'Plots', 'Commercial', 'Farmhouses', 'Villas'];
  const company = ['About Us', 'Contact', 'Careers', 'Blog', 'Press'];
  const legal = ['Terms of Service', 'Privacy Policy', 'Cookie Policy', 'Disclaimer'];

  const handleCityClick = (city, e) => {
    e.preventDefault();
    sessionStorage.setItem('searchParams', JSON.stringify({ city }));
    if (window.navigateTo) {
      window.navigateTo('listings');
    }
  };

  const handleTypeClick = (type, e) => {
    e.preventDefault();
    sessionStorage.setItem('searchParams', JSON.stringify({ propertyType: type.slice(0, -1) }));
    if (window.navigateTo) {
      window.navigateTo('listings');
    }
  };

  const handleCompanyClick = (item, e) => {
    e.preventDefault();
    if (item === 'Blog') {
      if (window.navigateTo) {
        window.navigateTo('blogs');
      }
    }
  };

  const handleSocialClick = (e) => {
    e.preventDefault();
  };

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-column">
              <h3>PakMilkiyat</h3>
              <p className="footer-description">
                Pakistan's leading property portal, connecting buyers and sellers across the nation.
              </p>
              <div className="social-links">
                <a href="#facebook" className="social-icon" aria-label="Facebook" onClick={handleSocialClick}>
                  <FacebookIcon size={20} />
                </a>
                <a href="#twitter" className="social-icon" aria-label="Twitter" onClick={handleSocialClick}>
                  <TwitterIcon size={20} />
                </a>
                <a href="#instagram" className="social-icon" aria-label="Instagram" onClick={handleSocialClick}>
                  <InstagramIcon size={20} />
                </a>
                <a href="#linkedin" className="social-icon" aria-label="LinkedIn" onClick={handleSocialClick}>
                  <LinkedInIcon size={20} />
                </a>
              </div>
            </div>

            <div className="footer-column">
              <h4>Popular Cities</h4>
              <ul className="footer-links">
                {cities.map(city => (
                  <li key={city}>
                    <a href={`#${city.toLowerCase()}`} onClick={(e) => handleCityClick(city, e)}>{city}</a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-column">
              <h4>Property Types</h4>
              <ul className="footer-links">
                {propertyTypes.map(type => (
                  <li key={type}>
                    <a href={`#${type.toLowerCase()}`} onClick={(e) => handleTypeClick(type, e)}>{type}</a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-column">
              <h4>Company</h4>
              <ul className="footer-links">
                {company.map(item => (
                  <li key={item}>
                    <a href={`#${item.toLowerCase().replace(' ', '-')}`} onClick={(e) => handleCompanyClick(item, e)}>{item}</a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-column">
              <h4>Legal</h4>
              <ul className="footer-links">
                {legal.map(item => (
                  <li key={item}>
                    <a href={`#${item.toLowerCase().replace(' ', '-')}`} onClick={(e) => e.preventDefault()}>{item}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; 2024 PakMilkiyat.com. All rights reserved.</p>
            {/* <p className="made-with-love">
              Made with <HeartIcon size={14} color="#e74c3c" filled={true} /> in Pakistan
            </p> */}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
